import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-biology',
  templateUrl: './biology.component.html',
  styleUrls: ['./biology.component.scss']
})
export class BiologyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
